<div class="container-workers">
  <div class="container-workers__wrapper">
    <div class="header">
      <h1 class="header__title">
          {{'tachographChart'|translate}}
      </h1>

      <p-tabMenu
        [model]="TABS"
        [activeItem]="activeTabOption()"
        class="header__tab-menu"
      ></p-tabMenu>
    </div>

    <div class="content">
      <div class="filters-row">
        <div class="content__filters">
          <app-filter-control
            *ngIf="activeView() === VIEW.Drivers"
            [selectedControlValue]="filtersDriversValue()"
            (onSubmitFilters$)="onChangeDriver($event)"
            [data]="filtersDriversConfig()!"
            [isVisibleSearchInput]="true"
            [optionsSelectedCount]="filtersDriversValue()?.selectedControlValue ? 1 : 0"
            class="content__filters__driver"
          ></app-filter-control>
          <app-filter-control
            *ngIf="activeView() === VIEW.Vehicles"
            [selectedControlValue]="filtersVehiclesValue()"
            (onSubmitFilters$)="onChangeVehicle($event)"
            [data]="filtersVehiclesConfig()!"
            [isVisibleSearchInput]="true"
            [optionsSelectedCount]="filtersVehiclesValue()?.selectedControlValue ? 1 : 0"
            class="content__filters__driver"
          ></app-filter-control>
          <app-date-picker
            [ngModel]="selectedDate()"
            (ngModelChange)="selectedDate.set($event)"
            [maxRangeDays]="30"
            [maxSelectableDays]="30"
            [numberOfMonths]="2"
            selectionMode="range"
          ></app-date-picker>
          <p-button
            (onClick)="submitFilters()"
            [disabled]="!selectedDate()?.length || (!filtersDriversValue() && !filtersVehiclesValue())"
            class="submit-filters"
            [label]="'reports.generateReport'|translate"
          />
        </div>

        <div *ngIf="tachographData()?.length" class="toolbox">
          <span class="toolbox__title">{{'chartParams.exportChartView'|translate}}:</span>
<!--
          <button class="toolbox__btn image">
              <i class="pi pi-image"></i>
          </button> -->
          <button (click)="generateXlsFile()" class="toolbox__btn xls">
              <i class="pi pi-file-o"></i>
          </button>
          <button (click)="generatePDFFile()" class="toolbox__btn pdf">
              <i class="pi pi-file-pdf"></i>
          </button>
        </div>
      </div>

      <div class="info">
        <span
          [pTooltip]="tooltipContent"
          tooltipStyleClass="tooltip--tacho"
          tooltipPosition="bottom"
          class="info__desc"
        >
          {{ 'tachographInfoAboutDelay' | translate }} <span class="info__desc--blue">{{'moreInformation'|translate}}</span>
        </span>
      </div>

      <div #containerList class="content__list">
        <ng-container *ngIf="!isLoadingData()">
          <app-tachograph-day-list *ngFor="let item of tachographData()" [tachographData]="item" class="content__list__data"></app-tachograph-day-list>
          <app-tachograph-empty-state *ngIf="!tachographData().length"></app-tachograph-empty-state>
        </ng-container>

        <div *ngIf="isLoadingData()" class="skeleton-loader">
          <p-skeleton *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11]" height="10rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #tooltipContent>
  <div class="tooltip-info-tacho">
    <span>
      {{ 'tachographInfoDelayTooltip' | translate }}
    </span>
  </div>
</ng-template>
